const devConfig = {
  apiBaseUrl: 'https://dev.magnifi.com/api',
  oktaClientId: '0oa1k4uyv06twnAW8697',
  oktaIssuer: 'magnifi-dev.okta.com'
}

export default devConfig
